import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './Video_principal.css';
import axios from 'axios';
import VistasPaginaBadge from '../components/VistasPaginaBadge';
import VerHistorias from '../components/VerHistorias';

function VideoPrincipal() {
  const [videos, setVideos] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const navigate = useNavigate();

  const [perfilesPremium, setPerfilesPremium] = useState([]);
  const [perfilesDestacado, setPerfilesDestacado] = useState([]);
  const [perfilPremiumSeleccionado, setPerfilPremiumSeleccionado] = useState(null);
  const [perfilDestacadoSeleccionado, setPerfilDestacadoSeleccionado] = useState(null);
  const scrollPremiumRef = useRef(null);
  const scrollDestacadoRef = useRef(null);

  const API_VIEWER = process.env.REACT_APP_HISTORIAS_VIEWER_URL;
  const UPLOADS_URL = process.env.REACT_APP_UPLOADS_URL;

  useEffect(() => {
    fetch(`${API_VIEWER}/get_historias_premium.php`)
      .then(res => res.json())
      .then(data => { if (data.success) setPerfilesPremium(data.data || []); })
      .catch(err => console.error('Error cargando historias premium:', err));
  }, [API_VIEWER]);

  useEffect(() => {
    fetch(`${API_VIEWER}/get_historias_destacadas.php`)
      .then(res => res.json())
      .then(data => { if (data.success) setPerfilesDestacado(data.data || []); })
      .catch(err => console.error('Error cargando historias destacadas:', err));
  }, [API_VIEWER]);

  // useEffect #1: Cargar videos
  useEffect(() => {
    console.log('📄 Cargando videos principales...');
    
    axios.get(`${process.env.REACT_APP_VIDEO_PRINCIPAL_URL}/Videos_principales_get.php?limit=15&page=${page}`)
      .then(res => {
        console.log('✅ Respuesta recibida:', res.data);
        
        let data = res.data;
        
        // Si es string, intentar parsearlo como JSON
        if (typeof data === 'string') {
          try {
            data = JSON.parse(data);
          } catch (e) {
            console.error('❌ No se pudo parsear JSON:', e);
            data = [];
          }
        }
        
        // Asegurar que sea array
        if (Array.isArray(data)) {
          const dataConVideo = data.filter(video => !!video.Nombre);
          // Mapear los datos del backend al formato esperado
          const videosFormateados = dataConVideo.map(video => ({
            id: video.ID,
            titulo: video.Titulo || 'Sin título',
            descripcion: video.Descripcion || 'Sin descripción',
            thumbnail: `${process.env.REACT_APP_UPLOADS_URL}/VIDEO_PRINCIPAL.jpg`,
            videoUrl: video.video_url,
            nombre: video.Nombre,
            visualizaciones: video.Visualizaciones || 0
          }));
          
          console.log('📹 Videos formateados:', videosFormateados);
          setVideos(videosFormateados);
          setHasMore(data.length === 15);
        } else {
          console.warn('⚠️ Data no es array:', data);
          setVideos([]);
        }
      })
      .catch(err => {
        console.error('❌ Error al cargar videos:', err);
        setVideos([]);
      });
  }, [page]);

  // useEffect #2: Verificar sesión activa
  useEffect(() => {
    const userToken = localStorage.getItem('userToken');
    setIsUserLoggedIn(!!userToken);
  }, []);

  // Obtiene o genera un token unico persistente para este navegador (usado para contar visualizaciones reales)
  const getViewerToken = () => {
    let token = localStorage.getItem('viewer_token');
    if (!token) {
      token = 'vt_' + Date.now() + '_' + Math.random().toString(36).substring(2, 12);
      localStorage.setItem('viewer_token', token);
    }
    return token;
  };

  // Función para abrir el modal con el video seleccionado
  const handleVideoClick = (video) => {
    console.log('🎬 Reproduciendo video:', video);
    setSelectedVideo(video);
    setIsModalOpen(true);

    axios.post(`${process.env.REACT_APP_VIDEO_PRINCIPAL_URL}/registrar_visualizacion.php`, {
      video_id: video.id,
      token: getViewerToken()
    }).catch(err => console.error('Error registrando visualizacion:', err));
  };

  // Función para cerrar el modal
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedVideo(null);
  };

  // Obtener información del usuario logueado
  const userName = localStorage.getItem('userName');
  const userEmail = localStorage.getItem('userEmail');

return (
  <div className="video-principal-container">
    {/* Logo superior */}
    <div className="logo-container">
      <img src={`${process.env.REACT_APP_UPLOADS_URL}/logotipo_new8.jpg`} alt="Ulalaaa Logo" className="main-logo" />
    </div>

    <VistasPaginaBadge pagina="home" />

    {/* Banner de sesión de usuario (solo si está logueado) */}
    {isUserLoggedIn && (
      <div className="user-session-banner">
        <div className="session-info">
          <i className="fas fa-user-circle"></i>
          <div className="session-text">
            <span className="session-label">Inicio sesión:</span>
            <span className="session-user">{userName || userEmail}</span>
          </div>
        </div>
        <button 
          className="btn-mi-perfil"
          onClick={() => {
            navigate('/sesion_viewer');
          }}
        >
          Mi Perfil
        </button>
        <button 
          className="btn-cerrar-sesion"
          onClick={() => {
            // Limpiar localStorage
            localStorage.removeItem('userToken');
            localStorage.removeItem('userId');
            localStorage.removeItem('userName');
            localStorage.removeItem('userEmail');
            localStorage.removeItem('returnToProfile');
            
            // Actualizar estado
            setIsUserLoggedIn(false);
            
            // Redirigir a Home
            navigate('/');
          }}
        >
          Cerrar Sesión
        </button>
      </div>
    )}
      
      {/* Banner con Historias */}
      <div className="home-historias-banner">
        <div className="home-historias-title">HISTORIAS</div>

        {perfilesPremium.length > 0 && (
          <>
            <div className="home-hist-subtitulo home-hist-subtitulo-premium">HISTORIAS PREMIUM</div>
            <div className="home-hist-scroll-wrapper" ref={scrollPremiumRef}>
              <div className="home-hist-circulos">
                {perfilesPremium.map(perfil => (
                  <div
                    key={perfil.usuario_id}
                    className="home-hist-circulo-wrapper"
                    onClick={() => setPerfilPremiumSeleccionado(perfil)}
                  >
                    <div className="home-hist-circulo-anillo home-hist-anillo-premium">
                      <div className="home-hist-circulo-inner">
                        {perfil.fotos ? (
                          <img
                            src={`${UPLOADS_URL}/ID_${perfil.usuario_id}/${perfil.fotos}?v=${perfil.usuario_id}`}
                            alt={perfil.nombre}
                            className="home-hist-circulo-img"
                          />
                        ) : (
                          <div className="home-hist-circulo-vacio">
                            <span>{perfil.nombre?.charAt(0)}</span>
                          </div>
                        )}
                      </div>
                    </div>
                    <span className="home-hist-nombre">{perfil.nombre}</span>
                  </div>
                ))}
              </div>
              {perfilesPremium.length > 6 && (
                <button
                  className="home-hist-flecha"
                  onClick={() => scrollPremiumRef.current?.scrollBy({ left: 200, behavior: 'smooth' })}
                >➜</button>
              )}
            </div>
          </>
        )}

        {perfilesDestacado.length > 0 && (
          <>
            <div className="home-hist-subtitulo home-hist-subtitulo-destacado">HISTORIAS DESTACADAS</div>
            <div className="home-hist-scroll-wrapper" ref={scrollDestacadoRef}>
              <div className="home-hist-circulos">
                {perfilesDestacado.map(perfil => (
                  <div
                    key={perfil.usuario_id}
                    className="home-hist-circulo-wrapper"
                    onClick={() => setPerfilDestacadoSeleccionado(perfil)}
                  >
                    <div className="home-hist-circulo-anillo home-hist-anillo-destacado">
                      <div className="home-hist-circulo-inner">
                        {perfil.fotos ? (
                          <img
                            src={`${UPLOADS_URL}/ID_${perfil.usuario_id}/${perfil.fotos}?v=${perfil.usuario_id}`}
                            alt={perfil.nombre}
                            className="home-hist-circulo-img"
                          />
                        ) : (
                          <div className="home-hist-circulo-vacio home-hist-circulo-vacio-dest">
                            <span>{perfil.nombre?.charAt(0)}</span>
                          </div>
                        )}
                      </div>
                    </div>
                    <span className="home-hist-nombre">{perfil.nombre}</span>
                  </div>
                ))}
              </div>
              {perfilesDestacado.length > 6 && (
                <button
                  className="home-hist-flecha"
                  onClick={() => scrollDestacadoRef.current?.scrollBy({ left: 200, behavior: 'smooth' })}
                >➜</button>
              )}
            </div>
          </>
        )}
      </div>

      {/* Botón fuera del banner */}
      <div className="home-publicar-wrapper">
        <a href="/acceso-publicar" className="publicar-aviso-btn home-publicar-btn">
          <i className="fas fa-plus-circle"></i>
          <span className="publicar-aviso-textos">
            <span>PUBLICA TU AVISO - REGISTRATE</span>
            <span className="publicar-acceso-text">Acceso a tu cuenta</span>
          </span>
        </a>
      </div>

      {/* Modales VerHistorias */}
      {perfilPremiumSeleccionado && (
        <VerHistorias
          usuarioId={perfilPremiumSeleccionado.usuario_id}
          nombrePerfil={perfilPremiumSeleccionado.nombre}
          fotoPerfil={
            perfilPremiumSeleccionado.fotos
              ? `${UPLOADS_URL}/ID_${perfilPremiumSeleccionado.usuario_id}/${perfilPremiumSeleccionado.fotos}`
              : null
          }
          esCreador={false}
          onClose={() => setPerfilPremiumSeleccionado(null)}
        />
      )}
      {perfilDestacadoSeleccionado && (
        <VerHistorias
          usuarioId={perfilDestacadoSeleccionado.usuario_id}
          nombrePerfil={perfilDestacadoSeleccionado.nombre}
          fotoPerfil={
            perfilDestacadoSeleccionado.fotos
              ? `${UPLOADS_URL}/ID_${perfilDestacadoSeleccionado.usuario_id}/${perfilDestacadoSeleccionado.fotos}`
              : null
          }
          esCreador={false}
          onClose={() => setPerfilDestacadoSeleccionado(null)}
        />
      )}

      {/* Contenido principal - Grid de videos */}
      <div className="videos-content">
        <div className="vp-videos-grid">
          {videos.map((video) => (
            <div key={video.id} className="video-card" onClick={() => handleVideoClick(video)}>
<div className="vp-video-thumbnail">
  <img
    className="vp-thumb-video"
    src={`${process.env.REACT_APP_UPLOADS_URL}/logo_video_principal.jpg`}
    alt="Ulalaaa Logo"
  />
  <div className="play-button">
    <i className="fas fa-play"></i>
  </div>
</div>
              <div className="video-info">
                <div className="video-titulo-row">
                  <h3 className="video-titulo">{video.titulo}</h3>
                  <span className="video-vistas">
                    <i className="fas fa-eye"></i> {video.visualizaciones}
                  </span>
                </div>
                <p className="video-descripcion">{video.descripcion}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Paginación */}
      <div className="vp-pagination">
        <button
          className="vp-page-btn"
          onClick={() => setPage((p) => Math.max(p - 1, 1))}
          disabled={page === 1}
        >
          « Anterior
        </button>
        <span className="vp-page-actual">Página {page}</span>
        <button
          className="vp-page-btn"
          onClick={() => setPage((p) => p + 1)}
          disabled={!hasMore}
        >
          Siguiente »
        </button>
      </div>

            {/* Modal de reproducción de video */}
      {isModalOpen && selectedVideo && (
        <div className="video-modal-overlay" onClick={handleCloseModal}>
          <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={handleCloseModal}>
              <i className="fas fa-times"></i>
            </button>
            
            <div className="video-player-container">
              <video 
                className="video-player"
                controls
                autoPlay
                controlsList="nodownload"
              >
                <source src={selectedVideo.videoUrl} type="video/mp4" />
                Tu navegador no soporta la reproducción de videos.
              </video>
            </div>
            
            <div className="video-modal-info">
              <div className="video-titulo-row">
                <h2>{selectedVideo.titulo}</h2>
                <span className="video-vistas">
                  <i className="fas fa-eye"></i> {selectedVideo.visualizaciones}
                </span>
              </div>
              <p>{selectedVideo.descripcion}</p>
            </div>
          </div>
        </div>
      )}

{/* Botón de regreso */}
      <div className="button-container">
        <button onClick={() => navigate('/')} className="back-button">
          Volver al Inicio
        </button>
      </div>

      {/* Footer */}
      <footer className="home-footer">
        <div className="home-footer-top">
          <div className="home-footer-redes">
            <a href="https://www.instagram.com/ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.tiktok.com/@ulalaaaoficial2" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-tiktok"></i>
            </a>
            <a href="https://www.youtube.com/@ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://wa.me/56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-whatsapp"></i>
            </a>
            <a href="#" className="home-footer-social-link">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{width:'22px',height:'22px'}}>
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.259 5.63 5.905-5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="https://t.me/+56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-telegram"></i>
            </a>
          </div>
          <div className="home-footer-logo">
            <img
              src={`${process.env.REACT_APP_UPLOADS_URL}/logotipo_new8.jpg`}
              alt="Ulalaaa Logo"
              className="home-footer-logo-img"
            />
          </div>
          <div className="home-footer-legal-links">
            <a href="/textos-legales#terminos" className="home-footer-legal-btn">Información Legal - Términos y Condiciones</a>
            <a href="/textos-legales#privacidad" className="home-footer-legal-btn">Política de Privacidad</a>
          </div>
        </div>
        <div className="home-footer-texto">
          Ulalaaa, es un sitio web exclusivo para mayores de 18 años, tanto para las personas publicadas como las que lo visitan, las personas publicadas son verificadas de forma rigurosa, el cual han dado su consentimiento para ser publicadas, este sitio no es una agencia, es solo un medio publicitario que no interviene con ninguna relación laboral con las personas publicadas.
        </div>
        <div className="home-footer-copyright">
          ©2026 Ulalaaa - Todos los derechos Reservados.
        </div>
      </footer>
    </div>
  );
}

export default VideoPrincipal;
